import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PasswordPolicyDto } from '../interfaces/password-policy-dto';
import { envToken } from '../tokens/env-token';

@Injectable({
    providedIn: 'root'
})
export class PasswordPolicyService {
    private http = inject(HttpClient);
    private env = inject(envToken);

    passwordPolicyBaseUrl = '';
    policyBaseUrl = '';

    constructor() {
        this.passwordPolicyBaseUrl = this.env.apiUrl + '/api/v1/password-policy/enterprise/';
        this.policyBaseUrl = this.env.apiUrl + '/api/v1/policy/password/enterprise/';
    }

    getPasswordPolicy(enterpriseId: number): Observable<PasswordPolicyDto> {
        return this.http.get<PasswordPolicyDto>(`${this.passwordPolicyBaseUrl}${enterpriseId}`);
    }

    createPasswordPolicy(enterpriseId: number, passwordPolicyDto: Partial<PasswordPolicyDto>): Observable<PasswordPolicyDto> {
        return this.http.post<PasswordPolicyDto>(`${this.policyBaseUrl}${enterpriseId}`, passwordPolicyDto);
    }


}
